/*!
 * Copyright (C) Octillion Media LLC 2019
 * All Rights Reserved.
 */
import {
    getAdvertisers,
    getAdvertiserCategory
} from "../../helpers/api";

export const namespaced = true;

export const state = {
    advertisers: [],
    advertiserCategories: [],
    selectedAdvertiser: null,
    selectedAdvertiserForContext: {}
};
export const getters = {
    advertisers: state => state.advertisers,
    advertiserCategories: state => state.advertiserCategories,
    selectedAdvertiser: state => state.selectedAdvertiser,
    selectedAdvertiserForContext: state => state.selectedAdvertiserForContext
};

export const mutations = {
    setAdvertisers(state, newValue) {
        state.advertisers = newValue
    },
    setAdvertiserCategories(state, newValue) {
        state.advertiserCategories = newValue
    },
    setSelectedAdvertiser(state, newValue) {
        state.selectedAdvertiser = newValue
    },
    setSelectedAdvertiserForContext(state, { key, advertiser }) {
        // Set the selectedAdvertiser for a specific key/context
        state.selectedAdvertiserForContext[key] = advertiser;
    }
};

export const actions = {
    async fetchAdvertisers({ commit }, payload) {
        const actionType = payload.action || 'setAdvertisers';

        // Clone payload to avoid mutating original
        const requestPayload = { ...payload };
        delete requestPayload.action;

        try {
            const res = await getAdvertisers(requestPayload);
            commit(actionType, res?.data ?? []);
        } catch (err) {
            if (err?.status !== 'cancelled') {
                commit('setAdvertisers', []);
            }
        }
    },
    fetchAdvertiserCategories({commit}, payload = {}) {
        getAdvertiserCategory(payload).then(res => {
            if(res && res.data) {
                commit('setAdvertiserCategories', res.data)
            }
        })
    },
    setSelectedAdvertiser({ commit }, advertiser) {
        commit('setSelectedAdvertiser', advertiser);
    },
    setSelectedAdvertiserForContext({ commit }, { key, advertiser }) {
        commit('setSelectedAdvertiserForContext', { key, advertiser });
    }
};